/* eslint-disable */

/** unique or primary key constraints on table "argo.work_instruction_instance" */
export enum ArgoWorkInstructionInstanceConstraint {
  /** unique or primary key constraint on columns "work_instruction_instance_id" */
  WorkInstructionInstancePkey = 'work_instruction_instance_pkey'
}

/** select columns of table "argo.work_instruction_instance" */
export enum ArgoWorkInstructionInstanceSelectColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkInstructionVersionId = 'work_instruction_version_id'
}

/** update columns of table "argo.work_instruction_instance" */
export enum ArgoWorkInstructionInstanceUpdateColumn {
  /** column name */
  AssetId = 'asset_id',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  EndTime = 'end_time',
  /** column name */
  Id = 'id',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  StartTime = 'start_time',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id',
  /** column name */
  WorkInstructionVersionId = 'work_instruction_version_id'
}

